'use strict';
var $ = require('../internals/export');
var fround = require('../internals/math-fround');

// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$({ target: 'Math', stat: true }, { fround: fround });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.math.fround.js
// module id = 579
// module chunks = 0